import { Badge } from "@/components/ui/badge";
import type { SampleStatus } from "@/types";

export const SAMPLE_STATUS_LABELS: Record<SampleStatus, string> = {
  REQUESTED: "Requested",
  IN_PROGRESS: "In progress",
  DISPATCHED: "Dispatched",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  REVISION: "Revision asked",
  CANCELLED: "Cancelled",
};

const VARIANTS: Record<SampleStatus, "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue"> = {
  REQUESTED: "secondary",
  IN_PROGRESS: "blue",
  DISPATCHED: "default",
  APPROVED: "success",
  REJECTED: "destructive",
  REVISION: "warning",
  CANCELLED: "outline",
};

export function SampleStatusBadge({ status, round }: { status: SampleStatus; round?: number }) {
  return (
    <Badge variant={VARIANTS[status] || "outline"}>
      {SAMPLE_STATUS_LABELS[status] || status}
      {round && round > 1 ? ` · round ${round}` : ""}
    </Badge>
  );
}
